import { apiV1 } from '../../api/api';
import { getUploadError, MAX_UPLOAD_SIZE_BYTES, UPLOAD_SIZE_ERROR } from '../../helpers/fileUpload';

export const uploadFundingDocumentFiles = async ({ folderId, key, files, onProgress }) => {
  const failures = [];
  let uploaded = 0;

  await files.reduce(
    (previous, file, index) =>
      previous.then(async () => {
        if (onProgress) onProgress(index + 1, files.length);
        if (file.size > MAX_UPLOAD_SIZE_BYTES) {
          failures.push(`${file.name} : ${UPLOAD_SIZE_ERROR}`);
          return;
        }

        const formData = new FormData();
        formData.append('key', key);
        formData.append('file', file, file.name);
        try {
          await apiV1.post(`/folders/${folderId}/funding_documents`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          uploaded += 1;
        } catch (uploadFailure) {
          failures.push(`${file.name} : ${getUploadError(uploadFailure)}`);
        }
      }),
    Promise.resolve(),
  );

  return { uploaded, failures };
};

export const uploadProgressMessage = (position, total) =>
  `Envoi du fichier ${position} sur ${total}…`;

export const uploadSummaryMessage = (uploaded, total) =>
  `${uploaded} fichier${uploaded > 1 ? 's' : ''} ajouté${uploaded > 1 ? 's' : ''} sur ${total}.`;
